import { CSSProperties, FC } from 'react';

import { REGION_LABEL_TEXT_COLOR } from '../../constants';
import { Divider } from '../util/constants';
import { TextOnCanvas } from '../util/textOnCanvas';

const regionLabelStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  fontSize: '16px',
  fontWeight: 800,
  height: '48px',
  minHeight: '48px',
  color: REGION_LABEL_TEXT_COLOR,
};

interface RegionLabelProps {
  text: string;
  score?: string;
  id?: string;
}

export const RegionLabel: FC<RegionLabelProps> = ({ text, score, id }) => {
  return (
    <div style={regionLabelStyle}>
      {text}
      {score && (
        <>
          <Divider />
          <TextOnCanvas text={score} id={id} color={REGION_LABEL_TEXT_COLOR} />
        </>
      )}
    </div>
  );
};
